import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { MarketplaceTranslationsRequest } from '~client/model/admin/marketplace-translations-request';
import { ResponseEntity } from '~client/model/response-entity';

/**
 * Adds translations to an existing marketplace
 * @param request
 */
export const performAddMarketplaceTranslations = (
  request: MarketplaceTranslationsRequest,
): Observable<ResponseEntity> =>
  apiClient.marketplaceAdminController.addMarketplaceTranslations$(request);



// WEBPACK FOOTER //
// ./interactor/marketplace/perform-add-marketplace-translations.ts